import type { RetrieveImageQuery, RetrieveImageResponse } from '$shared/api';
import { BaseService } from './utils/BaseService';

export class ImageService extends BaseService {
  retrieveImage(query: RetrieveImageQuery): Promise<RetrieveImageResponse> {
    return this.client.send('/api/image', {
      method: 'GET',
      query,
    });
  }
}
